import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

export const IncomeStatsCards = ({ stats }) => {
    return (
        <Row className="g-3 mb-4">
            <Col md={4}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Total Income</h6>
                            <i className="ri-money-dollar-circle-line fs-24 text-success"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.total.toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            All income this period
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">Recurring Income</h6>
                            <i className="ri-calendar-check-line fs-24 text-primary"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.recurring.toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Regular monthly income
                        </small>
                    </Card.Body>
                </Card>
            </Col>
            <Col md={4}>
                <Card className="card-one">
                    <Card.Body>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6 className="card-title">One-time Income</h6>
                            <i className="ri-coins-line fs-24 text-info"></i>
                        </div>
                        <h2 className="card-value mb-1">${stats.oneTime.toFixed(2)}</h2>
                        <small className="d-block fs-sm">
                            Non-recurring income
                        </small>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
}; 